// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck4FWodMnqTi2T {
  margin-top: 28px;
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  letter-spacing: -0.008em;
  line-height: 24px;
  font-weight: var(--ds-font-weight-semibold, 600);
  display: block;
  margin-top: var(--ds-space-800, 64px);
  margin-bottom: var(--ds-space-200, 16px);
  text-align: center;
}
.cqndyv22RyR21d {
  display: block;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
`, ""]);
// Exports
export var headerMessage = `ck4FWodMnqTi2T`;
export var secondaryMessage = `cqndyv22RyR21d`;
export default ___CSS_LOADER_EXPORT___;
